
export enum Priority {
  UP = 1,
  DOWN = 0
}
